<template>
  <div class="grid-content bg-purple treeContent">
    <h2 class="account-panel-head">
      {{this.title}}
      <i class="account-panel-hide" @click="ShoworgSearch()" v-if="flag&&false"></i>
    </h2>
    <div id="orgSearch" class="account-panel-detail">
      <div class="org-panel-srh">
        <i class="org-srh-icon" @click="clickSearch"></i>
        <input type="text" class="org-srh-input" v-model="searchexternaldata" placeholder="输入关键字，回车进行搜索" @keyup.enter="searchTXL">
      </div>
    </div>
    <el-table
      :height="tableHeight(cutHeight)"
      :data="tableDataExternal"
      size="mini"
      stripe
      :show-header="false"
      style="width: 100%;">
      <el-table-column label="公司名称" align="left">
        <template slot-scope="scope">
          <div style="cursor: pointer;width:100%" @click="handleExternalClick(scope.$index, scope.row)">
            {{scope.row.tenantname}}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" :layout="'prev, pager, next'" @bindgrid="bindExternalGrid" :pagerCount="5" :pagination="paginationExternal"></Pagination>
    </div>
  </div>
</template>

<script>

  import {tenantidlist} from '@/api/login';

  export default {
    name: 'TenantidListView',
    data() {
      return {
        searchexternaldata: '',
        loading: true,
        title: '请选择单位',
        flag: false,
        tenantid: '',
        paginationExternal: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableDataExternal: [],
      }
    },
    props: {
      showfirst: {
        default: false
      },
      cutHeight: {
        default: 140
      },
      ifuseaccount:{
        default:''
      }
    },
    methods: {
      handleExternalClick(index, row) {
        this.title = row.tenantname;
        if (!this.showfirst)//必须选中一个单位
          this.flag = true;
        this.$emit("select", row.unitguid)

      },
      ShoworgSearch() {
        this.title = '全部';
        this.flag = false;
        this.searchexternaldata = ""
        this.$emit("select", '')
      },
      searchTXL(ev) {
        if (ev.keyCode == 13)
          this.bindExternalGrid();
      },
      clickSearch() {
        this.bindExternalGrid();
      },
      bindExternalGrid() {
        tenantidlist({
          offset: (this.paginationExternal.currentPage - 1) * this.paginationExternal.pageSize,
          limit: this.paginationExternal.pageSize,
          tenantname: this.searchexternaldata,
          ifuseaccount: this.ifuseaccount
        }).then(response => {
          this.tableDataExternal = response.data.obj.rows
          this.paginationExternal.total = response.data.obj.total
          if (this.tenantid == "" && this.tableDataExternal.length > 0) {
            this.handleExternalClick(0, this.tableDataExternal[0]);
          }
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    mounted() {
      this.bindExternalGrid()
    },
    components: {}

  }
</script>
<style scoped>
  .account-panel-detail {
    position: relative;
    height: 100%;
  }

  .account-panel-head {
    position: relative;

    padding-left: 10px;

    font-size: 16px;
    line-height: 36px;

    color: #2586d9;
    border-bottom: 1px solid #ddd;
    background-color: #f4f4f4;
  }

  .account-panel-hide {
    position: absolute;
    top: 50%;
    right: 10px;
    width: 22px;
    height: 22px;
    margin-top: -11px;
    cursor: pointer;
    background: url('../../assets/images/icon-toright-clean.png');
  }

  .org-panel-srh {
    display: table;
    width: 100%;
    margin: 10px;
  }

  .org-srh-input,
  .org-srh-icon {
    display: table-cell;
  }

  .org-srh-icon {
    cursor: pointer;
    width: 35px;
    background: url(../../assets/images/search-bg.png);
  }

  .org-srh-input {
    width: 80%;
    height: 28px;
    padding-left: 6px;

    font-size: 12px;
    line-height: 28px;

    color: #666;

    border: 1px solid #2a92eb;
    border-left: 0;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    outline: none;
    float: left;
  }
</style>

<style>

  .txlTD {
    padding: 4px 0 !important;
  }

</style>

<style scoped>
  .logo-box {
    overflow: hidden;
    width: 255px;
    height: 48px;
  }

  .logo {
    display: block;
    margin: 0px 0 0 0px;
  }

  .l {
    float: left;
  }

  .list-first {
    position: relative;
    z-index: 10;
    overflow: hidden;
    width: 730px;
    height: 40px;
    margin-top: 5px;
    margin-right: 8px;
    margin-left: 8px;
    border-radius: 4px;
  }

  .item-first.select {
    color: #fff;
    background: #2590eb;
  }

  .item-first:hover {
    background: #5987c6;
  }

  .item-first.select:hover {
    background: #2590eb;
  }

  .item-first {
    overflow: hidden;
    width: 90px;
    height: 30px;
    margin: 2px 2px;
    font-size: 14px;
    line-height: 30px;
    cursor: pointer;
    -webkit-transition: all .6s cubic-bezier(.25, .46, .45, .94);
    transition: all .6s cubic-bezier(.25, .46, .45, .94);
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #cce2ff;
    border-radius: 4px;
  }

  .first-menu {
    width: 760px;
    margin-right: 6px;
    margin-top: 3px;
  }

  .menu-down {
    display: none;
    width: 28px;
    height: 28px;
    margin: 5px 5px 0 5px;
    background: url(../../assets/images/first-menu-btn.png);
  }

  .top-right-content {
    margin-right: 5px;
  }

  .r {
    float: right !important;
  }

  .top-right {
    padding-top: 10px;
  }

  .top-right > a {
    display: block;
    float: left;
    width: 24px;
    height: 24px;
    margin-top: 2px;
    margin-right: 10px;
  }

  .qrcode {
    background: url(../../assets/images/qrcode.png);
  }

  .qrcode:hover {
    background: url(../../assets/images/qrcode-active.png);
  }

  .RiconChange {
    background: url(../../assets/images/RiconChange.png);
  }

  .RiconChange:hover {
    background: url(../../assets/images/RiconChange-active.png);
  }

  .AddressList {
    background: url(../../assets/images/AddressList.png);
  }

  .AddressList:hover {
    background: url(../../assets/images/AddressList-active.png);
  }

  .remind-num, .remind-msg-num {
    position: absolute;
    display: block;
    height: 13px;
    margin: -5px 0 0 15px;
    padding: 0 3px;
    font-size: 12px;
    line-height: 13px;
    color: #fff;
    border-radius: 6px;
    background: #f73f07;
  }

  .hidden {
    display: none !important;
  }

  .center-line {
    width: 0;
    height: 22px;
    margin-top: 3px;
    margin-right: 10px;
    border-left: 1px solid #92add2;
  }

  .head-img {
    display: block;
    width: 28px;
    height: 28px;
    cursor: pointer;
    border-radius: 50%;
    padding: 0px;
    background-color: #fff;
    border: 0px solid rgba(0, 0, 0, 0.15);
  }

  .user {
    width: 170px;
  }

  .user_name {
    color: #fff;
    padding: 8px;
    line-height: 26px;
    font-size: 14px;
    cursor: pointer;
  }

  .user-box {
    position: absolute;
    z-index: 10;
    width: 278px;
    margin-top: 12px;
    margin-left: -108px;
    padding-top: 0px;
  }

  .info {
    height: 62px;
    border-bottom: 1px solid #3a7bd3;
    background: #346dba;
  }

  .big-head {
    display: block;
    width: 46px;
    height: 46px;
    margin: 5px 15px 0 15px;
    cursor: pointer;
    display: block;
    padding: 1px;
    background-color: #fff;
    border: 0px solid rgba(0, 0, 0, 0.15);
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .user {
    height: 45px;
  }

  .user-txt {
    margin-top: 6px;
    width: 180px;
    text-align: left;
  }

  .username {
    font-size: 15px;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .departname {
    font-size: 12px;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .setting {
    border-bottom: 1px solid #3a7bd3;
    height: 60px;
  }

  .setting-item {
    float: left;
    width: 92px;
    padding-top: 38px;
    cursor: pointer;
    -webkit-transition: all .6s cubic-bezier(.25, .46, .45, .94);
    transition: all .6s cubic-bezier(.25, .46, .45, .94);
    text-align: center;
    color: #fff;
    border-right: 1px solid #3a7bd3;
    background-color: #346dba !important;
  }

  .setting-item:hover {
    background-color: #185197 !important;
  }

  .personal {
    background: url(../../assets/images/p-head.png) center 12px no-repeat;
  }

  .changemobile {
    background: url(../../assets/images/setting.png) center 12px no-repeat;
  }

  .changepassword {
    background: url(../../assets/images/function.png) center 11px no-repeat;
  }

  .no-border {
    border: none;
  }

  .cancel-out {
    padding-top: 10px;
    padding-left: 12px;
    background: #346dba;
    height: 48px;
    cursor: pointer;
  }

  .loginout {
    display: inline-block;
    width: 250px;
    height: 36px;
    font-size: 15px;
    line-height: 36px;
    -webkit-transition: background .6s cubic-bezier(.25, .46, .45, .94);
    transition: background .6s cubic-bezier(.25, .46, .45, .94);
    text-align: center;
    color: #fff;
    border-radius: 4px;
    background: #f96d41;
  }

  .loginout:hover {
    background: #ff812d;
  }

  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }
</style>



// WEBPACK FOOTER //
// src/components/sysmanage/TenantidListView.vue